import { render, staticRenderFns } from "./btn-quarternary3.vue?vue&type=template&id=62b633a6&scoped=true&"
import script from "./btn-quarternary3.vue?vue&type=script&lang=js&"
export * from "./btn-quarternary3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b633a6",
  null
  
)

export default component.exports